import { TraderBalance } from "@components/balance";
import { Devices } from "@components/devices";
import { FlexLoader } from "@components/loader";
import { Notifications } from "@components/notifications";
import { Profit } from "@components/profit";
import { TopUpBalanceModal } from "@components/top-up-balance-modal";
import { useBalance } from "@features/balance";
import { balanceIsValid } from "@features/balance/helpers";
import { useBoolState } from "@hooks/use-bool-state";
import { useNavigate } from "react-router-dom";
import styles from "./main.module.scss";
import { useEffect } from "react";
import { useWebSocket } from "@request/useWebsocket";
import { WebsocketUpdateType } from "@request/websocket";

export const MainPage = () => {
  const navigate = useNavigate();
  const [isModalOpen, showModal, hideModal] = useBoolState(false);

  const { state, getBalances, getSaveFrozenBalance } = useBalance();
  const { lastMessage } = useWebSocket();

  const websocketTypesToUpdateBalance = [
    WebsocketUpdateType.Balance,
    WebsocketUpdateType.Withdrawal,
    WebsocketUpdateType.Appeal,
    WebsocketUpdateType.Order,
    WebsocketUpdateType.PayOut,
  ];

  useEffect(() => {
    if (
      lastMessage &&
      websocketTypesToUpdateBalance.includes(lastMessage.type)
    ) {
      getBalances();
      getSaveFrozenBalance();
    }
  }, [lastMessage]);
  useEffect(() => {
    getBalances();
    getSaveFrozenBalance();
  }, []);

  if (!balanceIsValid(state)) {
    return null;
  }

  const ern = state.payIn + state.payOut;

  return (
    <>
      <div>
        <div className={styles.top}>
          <div className={styles.topLeft}>
            {state.loading || state.loadingSave ? (
              <FlexLoader />
            ) : (
              <>
                <TraderBalance
                  className={styles.trusted}
                  type="trusted"
                  balance={state.trust}
                  saveBalance={state.save}
                  onClick={showModal}
                />
                <TraderBalance
                  type="frozen"
                  balance={state.frozen}
                  onClick={() => {
                    navigate("finance/disputes");
                  }}
                />
              </>
            )}
          </div>
          <Profit profit={ern} />
        </div>
        <div className={styles.bottom}>
          <Devices />
          <Notifications />
        </div>
      </div>

      <TopUpBalanceModal isOpen={isModalOpen} hide={hideModal} />
    </>
  );
};
